import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNowStrict } from 'date-fns';
import { getLocale } from '@vendasta/galaxy/utility/locale';

@Pipe({
  name: 'daysAgo',
  standalone: false,
})
export class DaysAgoPipe implements PipeTransform {
  transform(date: Date): string {
    if (!date) {
      return '';
    }
    return formatDistanceToNowStrict(date, { locale: getLocale(), addSuffix: true });
  }
}
